import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GroupData, LineData } from '@core/interfaces/analytics.interface';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
} from 'ng-apexcharts';

@Component({
  selector: 'app-stats-breakdown',
  template: `
    <div class="tab-buttons">
      <button [class.active]="activeTab === 'line'" (click)="setTab('line')">
        Por Línea
      </button>
      <button [class.active]="activeTab === 'group'" (click)="setTab('group')">
        Por Grupo
      </button>
    </div>
    <div *ngIf="hasData; else noData">
      <apx-chart
        [series]="series"
        [chart]="chart"
        [xaxis]="xaxis"
        [yaxis]="yaxis"
        [plotOptions]="plotOptions"
        [dataLabels]="dataLabels"
        [tooltip]="tooltip"
        [colors]="colors"
      ></apx-chart>
    </div>
    <ng-template #noData>
      <div class="no-data-msg">
        <i class="ri-bar-chart-line"></i>
        <span>Sin datos</span>
      </div>
    </ng-template>
  `,
  styles: [
    `
      .tab-buttons {
        display: flex;
        gap: 6px;
        margin-bottom: 12px;
      }
      .tab-buttons button {
        padding: 5px 14px;
        border: 1px solid #e0e0e0;
        border-radius: 20px;
        background: #f8f9fa;
        cursor: pointer;
        font-size: 12px;
        color: #666;
        transition: all 0.15s;
      }
      .tab-buttons button.active {
        background: #757fef;
        color: white;
        border-color: #757fef;
      }
      .no-data-msg {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 260px;
        color: #ccc;
        gap: 10px;
      }
      .no-data-msg i {
        font-size: 48px;
      }
      .no-data-msg span {
        font-size: 14px;
      }
    `,
  ],
})
export class StatsBreakdownComponent implements OnChanges {
  @Input() lineData: LineData[] = [];
  @Input() groupData: GroupData[] = [];

  activeTab: 'line' | 'group' = 'line';
  hasData = false;
  series: ApexAxisChartSeries = [];
  colors = ['#757fef'];

  chart: ApexChart = {
    type: 'bar',
    height: 290,
    toolbar: { show: false },
    fontFamily: 'inherit',
    animations: { enabled: true, speed: 400 },
  };

  plotOptions: ApexPlotOptions = {
    bar: { horizontal: false, columnWidth: '55%', borderRadius: 4 },
  };

  dataLabels: ApexDataLabels = { enabled: false };
  tooltip: ApexTooltip = {
    y: {
      formatter: (val: number) => val.toLocaleString('es') + ' participantes',
    },
  };

  xaxis: ApexXAxis = { categories: [] };
  yaxis: ApexYAxis = {
    labels: {
      formatter: (val: number) =>
        val >= 1000 ? (val / 1000).toFixed(0) + 'k' : String(Math.round(val)),
    },
  };

  setTab(tab: 'line' | 'group'): void {
    this.activeTab = tab;
    this.buildChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildChart();
  }

  buildChart(): void {
    const raw = this.activeTab === 'line' ? this.lineData : this.groupData;
    const trim = (s: string) => (s?.length > 22 ? s.slice(0, 22) + '…' : s);
    this.xaxis = {
      categories: raw.map((d) => trim(d.name)),
      labels: { rotate: -30 },
    };
    this.series = [{ name: 'Participantes', data: raw.map((d) => d.count) }];
    this.hasData = raw.length > 0;
    this.colors = this.activeTab === 'line' ? ['#757fef'] : ['#00b69b'];
  }
}
